import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import Validator from 'validatorjs'
import moment from 'moment'

import AddItemModal from 'components/AddItemModal'

import BasePureComponent from 'utils/BasePureComponent'

import Input from 'components/Input'
import DateInput from 'components/DateInput'
import Select from 'components/Select'
import FileInput from 'components/InputFile'

import AdditionalData from './AdditionalData'

import request from 'utils/request'

import {
  INSCURANCE_COMPANIES_URL,
  INSCURANCE_COVERAGES_URL,
  INSCURANCE_BROKERS_URL,
  VEHICLE_POLICIES_URL,
  POLICY_EXTRA_DATA,
  POLICY_FILE_URL,
  POLICY_DETAIL_URL
} from 'constants'

import { BROKER_TYPE } from 'components/AddItemModal/constants'

import {
  updateData,
} from 'components/PolicyForm/actions'

import './style.scss'


export class PolicyForm extends BasePureComponent {
  constructor(props) {
    super(props)
    this.VALIDATION_RULES = {
      company: 'numeric|required',
      issued_date: 'string|required',
      expiration_date: 'string|required',
      serial_number: 'required',
      policy_file: 'required',
    }

    this.state = {
      key: '',
      value: '',
      canCreateBroker: false,
      newBrokerLabel: '',
      coverages: [],
      // we need this to force re-render of _renderFooter
      submitting: false,
      errors: {}
    }
    this._bind(
      '_fetchInsuranceCompanies', '_fetchBrokers',
      '_validate', '_submit', '_submitFile', '_submitData', '_submitExtraData',
      '_onSelectChange', '_onInputChange', '_onFileChange',
      '_onError', '_onSuccess', '_validateDates',
      '_openNewBrokerModal', '_createBroker', '_fetchPeriodicicty', '_fetchCoverages',
      '_formatBody', '_filterCoverages'
    )
  }

  _onSuccess(policyId) {
    if (typeof this.props.onSuccess === 'function')
      this.props.onSuccess(policyId)
  }

  _onError(err) {
    // !!err && console.log(err)
    if (typeof this.props.onError === 'function')
      this.props.onError()
    this.setState({ submitting: false })
  }

  /*
  * Create or Update Policy Basic data
  * if policyId is received as prop HTTP method and endpoint-URL will change
  */
  _submit() {
    const method = !!this.props.policyId ? 'PUT' : 'POST'
    const url = !!this.props.policyId ? POLICY_DETAIL_URL(this.props.clientId, this.props.vehicleId, this.props.policyId) : VEHICLE_POLICIES_URL(this.props.clientId, this.props.vehicleId)
    request(url, {
      method: method,
      body: this._formatBody()
    })
    .then(({policy}) => {
      const hasExtraData = Object.keys(this.props.data.extra_data).length
      hasExtraData ? this._submitExtraData(policy.id) : this._submitFile(policy.id)
    })
    .catch(this._onError)
  }

  _formatBody() {
    let body = {
      company: this.props.data.company,
      broker: this.props.data.broker,
      issued_date: this.props.data.issued_date,
      expiration_date: this.props.data.expiration_date,
      number: this.props.data.serial_number
    }
    if (this.props.data.holder_name) {
      body.holder_name = this.props.data.holder_name
    }
    if (this.props.data.periodicity_type) {
      body.periodicity_type = this.props.data.periodicity_type
    }
    if (this.props.data.coverage) {
      body.coverage = this.props.data.coverage
    }
    if (this.props.data.custom_coverage) {
      body.custom_coverage = this.props.data.custom_coverage
    }
    if (this.props.data.first_charge_date) {
      body.first_charge_date = this.props.data.first_charge_date
    }
    return body
  }

  _validateDates() {
    const issuedDate = this.props.data.issued_date,
      expirationDate = this.props.data.expiration_date
    const valid = !!issuedDate && !!expirationDate && moment(issuedDate) < moment(expirationDate)
    let errors = {}
    if (!valid) {
      errors = {
        expiration_date: ['La fecha de expiración debe ser mayor a la de expedición']
      }
    }
    return { valid, errors }
  }

  _validate(success = null) {
    this.setState({ submitting: true })
    const validator = new Validator(this.props.data, this.VALIDATION_RULES)
    const { valid: validDates, errors: datesErrors } = this._validateDates()
    if(validator.passes() && validDates) {
      this._submit()
    } else {
      const errors = {
        ...datesErrors,
        ...validator.errors.errors
      }

      this.setState({ errors })
      this._onError(errors)
    }
  }

  _submitData() {
    this._validate()
  }

  _submitExtraData(policyId) {
    const data = Object.values(this.props.data.extra_data)
    const url = POLICY_EXTRA_DATA(this.props.clientId, this.props.vehicleId, policyId)

    request(url, {
      method: 'PUT',
      body: { data }
    })
    .then(() => {
      this._submitFile(policyId)
    })
    .catch(this._onError)
  }

  _submitFile(policyId) {
    const formData = new FormData()
    formData.append('file', this.props.data.policy_file)

    request(POLICY_FILE_URL(this.props.clientId, this.props.vehicleId, policyId), {
      method: 'PUT',
      isUpload: true,
      body: formData
    })
    .then((res) => {
      this._onSuccess(policyId)
    })
    .catch(this._onError)
  }

  _fetchInsuranceCompanies(label) {
    return request(`${INSCURANCE_COMPANIES_URL}?q=${label}`)
    .then(({companies}) => {
      const options = companies.map((company) => ({value: company.id, label: company.name}))
      return { options }
    })
    .catch(console.log)
  }

  _fetchBrokers(label) {
    return request(`${INSCURANCE_BROKERS_URL}?q=${label}`)
    .then(({brokers}) => {
      const options = brokers.map((broker) => ({value: broker.id, label: broker.name}))
      this.setState({ newBrokerLabel: label, canCreateBroker: !options.length })
      return { options }
    })
    .catch(console.log)
  }

  _fetchPeriodicicty(label) {
    this._fetchCoverages()
    const frequencies = ["Catorcenal", "Mensual", "Semestral", "Anual"]
    const options = frequencies.map((f) => ({value: f, label: f}))
    return new Promise(resolve => {
        resolve({options})
    })
  }

  _fetchCoverages(label) {
    return request(`${INSCURANCE_COVERAGES_URL}`)
    .then(({coverages}) => {
      this.setState({ coverages })
    })
    .catch(console.log)
  }

  _filterCoverages() {
    let cvs = this.state.coverages
    if ( this.props.data.company ) {
      cvs = cvs.filter((coverage) => { 
        return ( coverage.company === this.props.data.company ) && ( coverage.type !== 'Otro' )
      })
    }
    let options = cvs.map((coverage) => ({value: coverage.id, label: coverage.type}))
    return options
  }

  _onFileChange(e) {
    const file = e.target.files.length ? e.target.files[0] : null
    this.props.updateData(e.target.name, file)
  }

  _onInputChange(evt) {
    this.props.updateData(evt.target.name, evt.target.value)
    if ( evt.target.name === "issued_date" ) {
      this.props.updateData("first_charge_date", evt.target.value)
    }
  }

  _onSelectChange(name, selectedOption) {
    const value = !!selectedOption ? selectedOption.value : null
    this.props.updateData(name, value)
  }

  _createBroker(name) {
    request(INSCURANCE_BROKERS_URL, {
      method: 'POST',
      body: { name }
    })
    .then(({broker}) => {
      this.props.updateData('broker', broker.id)
      // force update of Select.options with current label
      // this will automatically put created value as selected
      this.brokerSelect.select.loadOptions(name)
    })
    .catch((err) => {
      const errors = !!err.fields ? {...err.fields} : {}
      this.setState({ errors })
    })
  }

  _openNewBrokerModal(evt) {
    evt.preventDefault()

    if (this.state.canCreateBroker && !!this.state.newBrokerLabel) {
      const Modal = (
        <AddItemModal
          itemType={BROKER_TYPE}
          itemName={this.state.newBrokerLabel}
          onConfirm={this._createBroker} />
      )
      const onClose = this.setState({ canCreateBroker: false, newBrokerLabel: '' })
      this.context.showSecondModal(Modal, { onClose })
    }

  }

  render() {
    return (
      <section id="PolicyForm" className="PolicyForm">
        <div className="PolicyForm__top">
          <div className="PolicyForm__top--first-row">
            <Select
              label="Aseguradora*"
              loadingPlaceholder="Buscando..."
              loadOptions={this._fetchInsuranceCompanies}
              noResultsText='Sin resultados'
              onChange={(v) => this._onSelectChange('company', v)}
              placeholder=""
              errors={this.state.errors.company}
              searchPromptText="Escribe para comenzar la búsqueda"
              value={this.props.data.company}
            />
            <Input
              errors={this.state.errors.serial_number}
              label="Número de póliza*"
              name="serial_number"
              onChange={this._onInputChange}
              value={this.props.data.serial_number}
            />
            <FileInput
              errors={this.state.errors.policy_file}
              label="Archivo de póliza*"
              labelType="light"
              name="policy_file"
              onChange={this._onFileChange}
              file={this.props.data.policy_file}
            />
          </div>
          <div className="PolicyForm__top--first-bottom-row">
            <Select
              label="Frecuencia de pago"
              loadingPlaceholder="Buscando..."
              loadOptions={this._fetchPeriodicicty}
              noResultsText='Sin resultados'
              onChange={(v) => this._onSelectChange('periodicity_type', v)}
              placeholder=""
              errors={this.state.errors.periodicity_type}
              searchPromptText="Escribe para comenzar la búsqueda"
              value={this.props.data.periodicity_type}
            />
            <Select
              label="Cobertura"
              loadingPlaceholder="Buscando..."
              options={this._filterCoverages()}
              noResultsText='Sin resultados'
              onChange={(v) => this._onSelectChange('coverage', v)}
              placeholder=""
              errors={this.state.errors.coverage}
              searchPromptText="Escribe para comenzar la búsqueda"
              value={this.props.data.coverage}
            />
            <div className="space-div">
            </div>
          </div>
          <div className="PolicyForm__top--second-row">
            <DateInput
              errors={this.state.errors.issued_date}
              label="Fecha de expedición*"
              name="issued_date"
              onChange={this._onInputChange}
              value={this.props.data.issued_date}
            />
            <DateInput
              errors={this.state.errors.expiration_date}
              label="Fecha de vigencia*"
              name="expiration_date"
              onChange={this._onInputChange}
              value={this.props.data.expiration_date}
            />
            <div className="space-div">
            </div>
          </div>
          <div className="PolicyForm__top--third-row">
            <Input
              label="Nombre del titular"
              name="holder_name"
              onChange={this._onInputChange}
              value={this.props.data.holder_name}
            />
            <Select
              cache={false}
              errors={this.state.errors.broker}
              label="Agente asegurador"
              loadingPlaceholder="Buscando..."
              loadOptions={this._fetchBrokers}
              noResultsText='Sin resultados - Da clic en el "+" para agregar marca'
              onChange={(v) => this._onSelectChange('broker', v)}
              ref={(select) => this.brokerSelect = select }
              placeholder=""
              searchPromptText="Escribe para comenzar la búsqueda"
              value={this.props.data.broker}
            />
            <button className="PolicyForm__top--third-row__add-btn" onClick={this._openNewBrokerModal}>
              <i className="material-icons">add</i>
            </button>
          </div>
        </div>
        <hr />
        <div className="PolicyForm__bottom">
          <h6>Datos adicionales</h6>
          <AdditionalData extraData={this.props.extraData}/>
        </div>
        <hr />
        {this.props.renderFooter(this._submitData)}
      </section>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    data: state.policyForm.get('data').toJS()
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateData: (name, value) => dispatch(updateData(name, value)),
  }
}

PolicyForm.contextTypes = {
  showSecondModal: PropTypes.func.isRequired
}

PolicyForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func,
  /*
  * this function will render any buttons needed on the footer
  * will receive `this._submitData` method-reference as prop so parent component can call
  * this method and perform policy creation or update
  * we did it like this since PolicyForm is a connected-Component
  * and we can't access to PolicyForm methods
  * this might have it's performance downsides but there is no other way to do PolicyForm
  * 100% standalone.
  */
  renderFooter: PropTypes.func,
  clientId: PropTypes.string.isRequired,
  vehicleId: PropTypes.number.isRequired,
  policyId: PropTypes.number
}


export default connect(mapStateToProps, mapDispatchToProps)(PolicyForm)



// WEBPACK FOOTER //
// ./src/components/PolicyForm/index.js